import { FindifyTopBarOverlay } from "../../genericPages/components/FindifyTopBarOverlay";
import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "../../genericPages/helpers/PlaceColors";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { FindifySimpleHeader, SimpleHeaderAction } from "../../genericPages/components/FindifySimpleHeader";
import { PlaceText } from "../../genericPages/components/PlaceText";
import { getApiFromModule } from "../../genericPages/helpers/GetContentsByModule";
import { Image, Pressable, ScrollView, Share, StyleSheet, View } from "react-native";
import { useTranslation } from "react-i18next";
import { DefaultShadow, IconShadow } from "../../genericPages/helpers/DefaultShadows";
import { BasePage } from "../../genericPages/helpers/BasePage";
import { BaseFindifyList } from "../../genericPages/components/FindifyList";
import { getTranslatedString } from "../../genericPages/helpers/FindifyTranslatedString";
import { getFeaturedImageUrl, getUniqueDays, makeDateString } from "@/layouts/genericPages/helpers/DetailsHelpers";



export const SchedulePage = ({ navigation }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const [events, setEvents] = useState<any[]>([]);
    const [availableDays, setAvailableDays] = useState<any[]>([]);
    const [selectedDayEvents, setSelectedDayEvents] = useState<any[]>([]);
    const [selectedDate, setSelectedDate] = useState<any>(null);
    const [sameYearDates, setSameYearDates] = useState(true);
    const { t } = useTranslation();
    const weekdays = [t('base.day.sunday'), t('base.day.monday'), t('base.day.tuesday'), t('base.day.wednesday'), t('base.day.thursday'), t('base.day.friday'), t('base.day.saturday')];
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);

    useEffect(() => {
        getApiFromModule('events', findifyDataContext)?.getList(0, 200, null, null, { orderby: JSON.stringify({ start_date: "ASC" }) }).then((res) => {
            const evs = res.results;
            setEvents(evs);
            const avDays = getUniqueDays(evs, setSameYearDates);
            setAvailableDays(avDays);
            setSelectedDate(avDays[0]);
        });

        setActionsList([{
            icon: 'share-outline',
            action: async () => {
                const result = await Share.share({
                    title: t('modules.content_types.events') + ' - ' + getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                    message: `https://${findifyDataContext.workspace?.primary_domain?.domain_name ?? 'links.findify.cloud'}/dynamicLink?workspace_id=${findifyDataContext.workspace?.workspace_id}&type=list&module=events`,
                }, {
                    dialogTitle: getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                });
            }
        }]);
    }, [])

    useEffect(() => {
        if (selectedDate) {
            const evs = events.filter((e: any) => e.start_date.startsWith(selectedDate));
            setSelectedDayEvents(evs);
        }
    }, [selectedDate])


    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <View
            style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                backgroundColor: PlaceColors(findifyDataContext).background.get(),
            }}>
            <FindifySimpleHeader
                navigation={navigation}
                title={findifyDataContext?.language?.startsWith('en') ? 'Events' : 'Eventos'}
                actions={actionsList}
                backgroundColor={PlaceColors(findifyDataContext).primary.get()}
                isEventLayout={true}
            />
            <View style={[styles.intro, { backgroundColor: PlaceColors(findifyDataContext).primary.get() }]}>
                <PlaceText style={styles.introEyebrow}>{findifyDataContext?.language?.startsWith('en') ? 'CAMINHA MUSEUM ROUTE' : 'ROTA DE MUSEUS DE CAMINHA'}</PlaceText>
                <PlaceText style={styles.introTitle}>{findifyDataContext?.language?.startsWith('en') ? 'What is happening?' : 'O que está a acontecer?'}</PlaceText>
                <PlaceText style={styles.introCopy}>{findifyDataContext?.language?.startsWith('en') ? 'Discover exhibitions, events and activities near you.' : 'Descubra exposições, eventos e atividades perto de si.'}</PlaceText>
            </View>
            <View style={styles.eventsSection}>
                <View style={styles.sectionHeading}><PlaceText style={[styles.sectionTitle, { color: PlaceColors(findifyDataContext).primary.get() }]}>{findifyDataContext?.language?.startsWith('en') ? 'Upcoming events' : 'Próximos eventos'}</PlaceText><PlaceText style={styles.swipeHint}>{findifyDataContext?.language?.startsWith('en') ? 'Swipe to explore' : 'Deslize para explorar'}</PlaceText></View>
                <View style={styles.cardsColumn}>
                    {events.map((event: any) => {
                        const start = new Date(event.start_date);
                        const end = new Date(event.end_date);
                        return <Pressable key={event.event_id} style={styles.eventCard} onPress={() => navigation.push('PlaceContentDetails', { module: 'events', content_id: event.event_id, page_slug: event.page_slug })}>
                            {getFeaturedImageUrl(event) ? <Image source={{ uri: getFeaturedImageUrl(event) }} style={styles.eventImage} resizeMode="cover" /> : <View style={[styles.eventImage, { backgroundColor: PlaceColors(findifyDataContext).primary.get() }]} />}
                            <View style={styles.eventShade} />
                            <View style={styles.eventCardBody}><PlaceText style={styles.eventDay}>{start.toLocaleDateString(findifyDataContext?.language?.startsWith('en') ? 'en-GB' : 'pt-PT', { weekday: 'short' }).toUpperCase()}</PlaceText><PlaceText style={styles.eventDate}>{start.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit' })} – {end.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit' })}</PlaceText><PlaceText style={styles.eventTitle} numberOfLines={3}>{getTranslatedString(event.name, findifyDataContext)}</PlaceText><PlaceText style={styles.eventMore}>{findifyDataContext?.language?.startsWith('en') ? 'View details  ›' : 'Ver detalhes  ›'}</PlaceText></View>
                        </Pressable>;
                    })}
                </View>
            </View>
        </View >
    </BasePage>
};

const styles = StyleSheet.create({
    topNav: {},
    dateZone: {
        ...DefaultShadow,
        width: '100%',
        paddingVertical: 14,
        paddingHorizontal: 14,
        gap: 10,

    },
    intro: { margin: 0, marginBottom: 10, borderBottomLeftRadius: 28, borderBottomRightRadius: 28, padding: 22, paddingTop: 12, gap: 7 },
    introEyebrow: { color: 'rgba(255,255,255,.72)', fontSize: 10, fontWeight: '900', letterSpacing: 1.2 },
    introTitle: { color: '#fff', fontSize: 27, fontWeight: '800', marginTop: 4 },
    introCopy: { color: 'rgba(255,255,255,.86)', fontSize: 14, lineHeight: 20 },
    dateLabel: { fontSize: 10, fontWeight: '900', letterSpacing: 1.1, marginLeft: 3 },
    bottomBox: {
        flex: 1,
    },
    eventsSection: { paddingHorizontal: 16, paddingTop: 18, gap: 12 },
    sectionHeading: { flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between' },
    sectionTitle: { fontSize: 22, fontWeight: '800' },
    swipeHint: { fontSize: 11, color: '#4FA5A1', fontWeight: '700' },
    cardsColumn: { gap: 14, paddingBottom: 24 },
    eventCard: { width: '100%', minHeight: 220, borderRadius: 20, overflow: 'hidden', backgroundColor: '#021E49', borderWidth: 1, borderColor: 'rgba(188,149,94,.35)', position: 'relative' },
    eventImage: { ...StyleSheet.absoluteFillObject, width: '100%', height: '100%' },
    eventShade: { ...StyleSheet.absoluteFillObject, backgroundColor: 'rgba(2,30,73,.58)' },
    eventCardBody: { flex: 1, justifyContent: 'flex-end', padding: 18, gap: 5, minHeight: 220 },
    eventDay: { color: '#BC955E', fontSize: 10, fontWeight: '900', letterSpacing: 1.1 },
    eventDate: { color: '#fff', fontSize: 12, fontWeight: '700' },
    eventTitle: { color: '#fff', fontSize: 18, lineHeight: 22, fontWeight: '800', minHeight: 58, marginTop: 4 },
    eventMore: { color: '#E7C58F', fontSize: 12, fontWeight: '800', marginTop: 5 },

    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
})
